// @flow
import React from 'react';

import { notFoundLibraryError, postPaymentExecute } from '../../duck';
import analytics from '../../../../../analytics';
import {endpoints, postPaymentExecuteApi} from '../../api';

import type { Node } from 'react';
import type { Order } from '../../../../../entities';
import type { ImplementationType, PaymentImpl } from '../index';
import type {BillingAddressReq, PaymentExecuteReq} from '../../api';

import type { RootState } from '../../../../index';

export default class PaypalPayment implements PaymentImpl {
  type: ImplementationType = 'paypal';
  uiId: string = 'paypalUI';
  order: Order;

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    
    if (!window.paypal) {
      dispatch(notFoundLibraryError({
        code: 404,
        name: 'notFoundLibraryError',
        url: '',
      }));
      return;
    }

    const button = window.paypal.Buttons({
      locale: 'es_ES',
      createOrder: function (data: any, actions: any) {
        analytics.fireCustomEvent('Checkout Step Completed', {
          category: 'Checkout Step',
          action: 'Completed',
          label: order.id,
          user_type: 'purchaser',
          user_referrer: window.localStorage.getItem('userReferrer') || '',
          landing_url: window.localStorage.getItem('landingUrl') || '',
          order_id: order.id,
          order_formatted_id: order.id,
          payment_method: order.invoice && order.invoice.payment ? order.invoice.payment.method : '',
          payment_sub_method: order.invoice && order.invoice.payment ? order.invoice.payment.subtype : '',
          domain_country: rootState.locale.domainCountry || '',
          type: 'sync',
          step: 1,
          shipping_method: order.serviceTier,
        });
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: order.invoice.payment.total
            }
          }]
        });
      },
      onApprove: function (data: any, actions: any) {
        analytics.fireCustomEvent('Payment Info Entered', {
          category: 'Payment Info',
          action: 'Entered',
          label: order.id,
          user_type: 'purchaser',
          user_referrer: window.localStorage.getItem('userReferrer') || '',
          landing_url: window.localStorage.getItem('landingUrl') || '',
          order_id: order.id,
          order_formatted_id: order.id,
          payment_method: order.invoice && order.invoice.payment ? order.invoice.payment.method : '',
          payment_sub_method: order.invoice && order.invoice.payment ? order.invoice.payment.subtype : '',
          domain_country: this.domainCountry,
          type: 'sync',
          step: 1,
          shipping_method: order.serviceTier,
        });
        dispatch(postPaymentExecute({
          type: order.invoice.payment.subtype,
          method: order.invoice.payment.method,
          paymentData: {
            token: data.orderID
          },
        }, order));
      }
    });
    button.render('#paypal-button-container');
  }

  generateCustomUI(): Node {
    return (
      <div id={this.uiId} style={{ textAlign: 'center', marginTop: '32px', minHeight: 85 }}>
        <div id="paypal-button-container"/>
      </div>
    );
  }

  executeUIAction = (billingAddress: BillingAddressReq, rootState: RootState) => {
    const order = rootState.newOrder.checkoutStep.order;

    if (order.invoice.payment.method === 'MANUAL_SETTLEMENT' && order.invoice.detail.total === '0.00') {
      const paymentRequest: PaymentExecuteReq = {
        method: this.order.invoice.payment.method,
        type: this.order.invoice.payment.subtype,
        billingAddress: billingAddress,
      }
      
      postPaymentExecuteApi(paymentRequest, {
        route: endpoints.POST_PAYMENT_EXECUTE.replace(':paymentId', this.order.invoice.payment.id),
      }).toPromise().then(
        (order: Order) => {
          if (['AVAILABLE', 'AVAILABLE_FOR_COURIER'].includes(order.state)) {
            window.location.reload();s
          }
        },
      ).catch(
        ({data}: {data: {message: string, name: string}}) => {
          console.log('Unsuccessful payment execution for Paypal!', error);
          if (data.name === 'InvalidStateError') {
            document.location.reload();
          }
        },
      )
    }
  };

  showPopUp = () => undefined;

  clean = () => {
    const $element = document.getElementById(this.uiId);
    if (document && $element) {
      // $element.remove();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/Paypal/index.js